<template>
  <el-card size="small" class="changer-user-card">
    <el-input
      ref="myInput"
      v-model="username"
      placeholder="请输入用户名称（邮箱前缀）"
      clearable
      @keydown.enter.native="submitForm"
    />
  </el-card>
</template>

<script>
// import axios from 'axios';
import axios from '@/API';

export default {
  data () {
    let gwUrl = '';
    if (window._env_.NODE_ENV !== 'pro') {
      gwUrl = 'web-e-gw.ruijie.com.cn';
    } else {
      gwUrl = 'web-e-gw.ruijie.com.cn';
    }
    return {
      gwUrl,
      username: '',
      changerStatusTypes: {
        SIMU_ENABLE: '允许模拟',
        SIMU_DISABLE: '无模拟权限',
        SIMUING: '模拟登录中'
      }
    };
  },
  methods: {
    /**
     * 确认登录
     * @return {Promise<void>}
     */
    submitForm () {
      axios.get(
        `https://${this.gwUrl}/api/union-session/imitate/session?unionSessionTicket=${localStorage.getItem('union_session_ticket')}&targetUserId=${this.username}`
      ).then(res => {
        let json = res.data;
        if (Number(json.status) === 200) {
          localStorage.setItem('union_session_ticket', json.data);
          this.$router.push('/');
        }
      }).catch(e => {
        console.log(e);
      });
    },
    /**
     * 校验权限 没权限就送回去
     * @return {Promise<void>}
     */
    verifyPermissions () {
      axios.get(
        `https://${this.gwUrl}/api/union-session/imitate/session/state?unionSessionTicket=${localStorage.getItem('union_session_ticket')}`
      ).then(res => {
        let json = res.data;
        if (Number(json.status) === 200) {
          console.log(json.data);
          if (json.data === 'SIMUING') {
            this.exitSimulatedLogin();
          } else if (json.data === 'SIMU_DISABLE') {
            this.$message.error(this.changerStatusTypes[json.data]);
            this.$router.back();
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    exitSimulatedLogin  () {
      axios.get(
        `https://${this.gwUrl}/api/union-session/imitate/session/exsit?unionSessionTicket=${localStorage.getItem('union_session_ticket')}`
      ).then(res => {
        let json = res.data;
        if (Number(json.status) === 200) {
          localStorage.setItem('union_session_ticket', json.data);
          window.location.reload();
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  mounted () {
    this.verifyPermissions();
  }
};
</script>

<style lang="scss" scoped>
.changer-user-card {
  width: 30vmax;
  margin: 30px auto;
  .ant-form-item {
    margin-bottom: 0 !important;
  }
}
</style>
